<template>
  <div class="modal is-modal" :class="{'is-active': active}">
    <div class="modal-background" @click.prevent.stop="close"></div>
    <div class="modal-card">
      <div class="row-width-actions-bar">
        <div class="columns is-gapless is-vcentered is-border-bottom">
          <div class="column is-padding-left">
            <div class="has-text-dark is-size-6 is-uppercase">
              <span class="has-text-weight-medium">Annuler procédure</span>
            </div>
          </div>
          <div class="column is-narrow is-border-left">
            <a class="page-header-btn is-small is-square" @click="close">
              <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
            </a>
          </div>
        </div>
      </div>
      <section class="modal-card-body is-clipped">
        <div class="is-border-bottom">
          <div class="is-padding has-text-centered">
            <span class="has-text-danger has-text-weight-medium is-size-4 is-uppercase">Souhaitez-vous vraiment annuler la procédure ?</span>
          </div>
        </div>
        <div>
          <div class="is-padding-top-small is-padding-right-small is-padding-left-small">
            <div class="is-padding-xsmall is-border-top is-border-right is-border-left">
							<span class="is-size-6">
								Vous pouvez renseigner ci-dessous les raisons de l'annulation de la procédure
							</span>
            </div>
          </div>
          <div class="is-padding-bottom-small is-padding-right-small is-padding-left-small">
            <wysiwyg-editor
              :light='true' :tooltip-top="true"
              :model="commentaire"
              @change="val => commentaire = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content">
            </wysiwyg-editor>
          </div>
        </div>
        <div class="columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
          <div class="control">
            <button @click="close()" class="button is-primary">
							<span>
								Annuler
							</span>
            </button>
          </div>
          <div class="is-padding-left control">
            <button @click="confirm()" class="button is-danger">
							<span>
								Confirmer
							</span>
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CancelProcedure',
    data () {
      return {
        commentaire: null
      }
    },
    props: {
      active: {
        type: Boolean,
        required: true
      }
    },
    methods: {
      confirm () {
        if (this.commentaire) {
          this.$emit('confirm', this.commentaire)
        } else {
          let params = {
            cancel: true
          }
          this.$emit('confirm', params)
        }
      },
      close () {
        this.$emit('close')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/CancelProcedure.vue